import { compressAndPostImage } from '@/assets/Services/compressorService';
import { get, put, post, remove } from '@/helpers/http';

const BASE_PATH = 'user';

export function fetchUsers(pagination = {}) {
  return get('/active/users', { ...pagination });
}

export function fetchBestWriters(limit) {
  return get('/best/writers', { limit });
}

export function fetchTopReaders(limit) {
  return get('/top/readers', { limit });
}

export function fetchTopWriters(limit) {
  return get('/top/writers', { limit });
}

export function fetchRanking(options) {
  return get('/ranking/users', options);
}

export function fetchFollowedUsers(user, pagination = {}) {
  return get('/followed/users', { followerId: user.id, ...pagination });
}

export function getDepartmentUsers(departmentId) {
  return get(`/department/users/${departmentId}`);
}

export function getCurrentUser() {
  return get(`${BASE_PATH}`);
}

export function getUserById(id) {
  return get(`/users/${id}`);
}

export function getFollowingStatus(user) {
  return get(`/isFollowing/user/${user.id}`);
}

export function getFollowers(user) {
  return get(`followers/user/${user.id}`);
}

export function updateUserVisits(user) {
  return put(`/user/visit/${user.id}`, user);
}

export function updateUserInformation(user) {
  return put(`/users/${user.id}`, user);
}

export function updateUserPreferences(preference) {
  return put(`/preferences/${preference.id}`, preference);
}

export function searchUsers(searchTerm, pagination = {}) {
  return post('/search/users', { search: searchTerm, ...pagination });
}

export function createNewUser(user) {
  return post('/users/', user);
}

export function importUsers(userList) {
  return post('/import/users', { userList });
}

export function followUser(user) {
  return post('/follow/user', { user_id: user.id });
}

export function unfollowUser(user) {
  return post('/unfollow/user', { user_id: user.id });
}

export function removeUser(user) {
  return remove(`/users/${user.id}`);
}

export function unblockUser(user) {
  return put(`/users/unblock/${user.id}`);
}

export function blockUser(user) {
  return put(`/users/block/${user.id}`);
}

export function uploadImageFiles(file) {
  return compressAndPostImage(file, '/file/upload/');
}

export function deleteFiles(filename) {
  return post('/file/delete', { filename });
}
